export default {
  props: {
    elementId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      elementBottom: 0,
      elementBottomObserver: null,
      mutationObserver: null,
    };
  },

  mounted() {
    this.initBottomMutation();
  },

  beforeDestroy() {
    this.destroyBottomObserver();
    this.destroyBottomMutation();
  },

  methods: {
    initBottomObserver() {
      const element = document.getElementById(this.elementId);
      if (!element) {
        console.warn('not found bottom element');
        return;
      }

      const domEl = element.$el || element;
      if (!domEl) return;

      this.elementBottomObserver = new ResizeObserver(entries => {
        for (const entry of entries) {
          const rect = domEl.getBoundingClientRect?.() || entry.contentRect;
          this.elementBottom = rect.bottom || (entry.contentRect.top + entry.contentRect.height);
        }
      });

      this.elementBottomObserver.observe(domEl);
    },

    destroyBottomObserver() {
      if (this.elementBottomObserver) {
        this.elementBottomObserver.disconnect();
        this.elementBottomObserver = null;
      }
    },

    initBottomMutation() {
      this.mutationObserver = new MutationObserver(() => {
        this.$nextTick(() => {
          const el = document.getElementById(this.elementId);

          if (el && !this.elementBottomObserver) {
            this.initBottomObserver();
          } else if (!el && this.elementBottomObserver) {
            this.destroyBottomObserver();
          }
        });
      });

      this.mutationObserver.observe(document.body, {
        childList: true,
        subtree: true,
      });

      this.$nextTick(() => this.initBottomObserver());
    },

    destroyBottomMutation() {
      if (this.mutationObserver) {
        this.mutationObserver.disconnect();
        this.mutationObserver = null;
      }
    },
  },
};
